/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdGroupRolesUpdateRequest
 */
export interface AdGroupRolesUpdateRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof AdGroupRolesUpdateRequest
     */
    roleIds?: Array<any> | null;
}

/**
 * Check if a given object implements the AdGroupRolesUpdateRequest interface.
 */
export function instanceOfAdGroupRolesUpdateRequest(value: object): value is AdGroupRolesUpdateRequest {
    return true;
}

export function AdGroupRolesUpdateRequestFromJSON(json: any): AdGroupRolesUpdateRequest {
    return AdGroupRolesUpdateRequestFromJSONTyped(json, false);
}

export function AdGroupRolesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdGroupRolesUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
    };
}

export function AdGroupRolesUpdateRequestToJSON(json: any): AdGroupRolesUpdateRequest {
    return AdGroupRolesUpdateRequestToJSONTyped(json, false);
}

export function AdGroupRolesUpdateRequestToJSONTyped(value?: AdGroupRolesUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleIds': value['roleIds'],
    };
}

